"use strict";

module.exports = function toString() {
    var i, prop, thisValue;
    if (this.getCall && this.callCount) {
        i = this.callCount;

        while (i--) {
            thisValue = this.getCall(i).thisValue;

            for (prop in thisValue) {
                if (thisValue[prop] === this) {
                    return prop;
                }
            }
        }
    }

    return this.displayName || "sinon fake";
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/sinon/lib/sinon/util/core/function-to-string.js
// module id = 612
// module chunks = 0